import { StyleSheet, Text, View, Image } from '@react-pdf/renderer';
import React, { useMemo } from 'react';
import useBackwardsCompatible from '../../../../hooks/useBackwardsCompatible';
import { Dashboard, DashboardQuerySource } from '../../../../types/files';
import theme from '../../../../theme';

const styles = StyleSheet.create({
    queryBlock: {
        width: '100%',
        height: 'auto',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
    },
    answerBlock: {
        width: '100%',
        height: 'auto',
        paddingTop: 8,
        paddingBottom: 8,
        color: '#666666',
    },
    title: {
        fontFamily: 'Poppins',
        fontSize: 12,
        fontWeight: 'bold',
        color: '#666666',
    },
    row: {
        flexDirection: 'row',
        alignItems: 'stretch',
        justifyContent: 'flex-start',
        width: '100%',
        minHeight: 24,
    },
    col: {
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'center',
        marginLeft: 4,
    },
    icon: {
        width: 12,
        height: 12,
    },
    label: {
        fontFamily: 'Lato',
        fontSize: 10,
        fontWeight: 600,
        color: theme.palette.primary.main,
        paddingHorizontal: 1,
    },
    sublabel: {
        fontFamily: 'Lato',
        fontSize: 9,
        fontWeight: 500,
        color: '#666666',
    },
});

const PDFDealSource: React.FC<{ dashboard: Dashboard }> = ({ dashboard }) => {
    const { dashboardSource } = useBackwardsCompatible();

    const source = useMemo(() => {
        const dealSource = dashboardSource(dashboard);

        return (dealSource?.name !== DashboardQuerySource.LINKEDIN) ? dealSource : undefined;
    }, [dashboard, dashboardSource]);

    return (<>
        <View style={styles.queryBlock}>
            <Text style={styles.title}>
                {'Deal Source'}
            </Text>
            <View style={styles.answerBlock}>
                <View style={styles.row}>
                    {(!!source?.name || !!source?.email) ? (<>
                        <Image style={styles.icon} src={'/images/user-gray.png'} />
                        <View style={styles.col}>
                            {!!source?.name && (
                                <Text style={styles.label}>{source.name}</Text>
                            )}
                            {!!source?.email && (
                                <Text style={[styles.label, styles.sublabel]}>{source.email}</Text>
                            )}
                        </View>
                    </>) : (
                        <Text style={[styles.label, styles.sublabel]}>{'No deal source'}</Text>
                    )}
                </View>
            </View>
        </View>
    </>);
}

export default PDFDealSource;
